import { lookupCard } from "../../content/index.js";
import type { ApplyEffectContext } from "./effectContext.js";

export function startStables(ctx: ApplyEffectContext): ApplyEffectContext {
  const hasWorker = ctx.run.hand.some((card) => lookupCard(card.cardId)?.type === "worker");
  if (!hasWorker) return ctx;
  return {
    ...ctx,
    run: {
      ...ctx.run,
      pendingChoice: {
        kind: "stables",
        sourceInstanceId: ctx.sourceInstanceId,
        selected: [],
      },
    },
  };
}
